import { post, get } from './apiClient';

export interface CacheClearResult {
    success: boolean;
    data?: { success: boolean; message: string; section: string; timestamp: string; durationMs: number };
    error?: string;
}

export interface ServiceCacheResult {
    success: boolean;
    service: string;
    data?: any;
    error?: string;
    reachable?: boolean;
}

export interface ServiceEntry { id: string; label: string; }

export const getServices              = () => get<{ success: boolean; data: ServiceEntry[] }>('/config-cache/services');
export const clearTenantSettingsCache = () => post<CacheClearResult>('/config-cache/clear/tenant-settings', {});
export const clearClusterSettingsCache = () => post<CacheClearResult>('/config-cache/clear/cluster-settings', {});

export const getServiceStatus  = (service: string) => get<ServiceCacheResult>(`/config-cache/services/${service}/status`);
export const reloadService     = (service: string) => post<ServiceCacheResult>(`/config-cache/services/${service}/reload`, {});
export const clearServiceCache = (service: string) => post<ServiceCacheResult>(`/config-cache/services/${service}/clear-tenant`, {});
export const reloadAllServices = () => post<{ success: boolean; results: Record<string, ServiceCacheResult> }>('/config-cache/services/reload-all', {});
